import { isValidEmail } from '@domain-group/javascript-utils'

const state = {
  api_user: false,
  association_id: undefined,
  association_type: '',
  brand_custom_profile_user_profile_ids: {
    property_marketing: undefined,
    agency_marketing: undefined,
    notifications: undefined,
  },
  country_calling_code: '+61',
  custom_permissions: {},
  customizable_permissions: {},
  data: {},
  deleted: false,
  email: '',
  enable_brand_custom_profiles: false,
  enable_custom_permissions: false,
  first_name: '',
  id: null,
  image_id: undefined,
  last_name: '',
  mobile_number: '',
  options: {
    training_mode: false,
  },
  password: '',
  password_confirmation: '',
  role_id: undefined,
  second_factor_attempts_count: undefined,
  template_master: false,
  time_zone: '',
  username: '',
}

export const requiredFields = [
  { key: 'email', validation: isValidEmail, invalidMessage: 'Invalid Email format' },
  { key: 'first_name' },
  { key: 'last_name' },
  { key: 'role_id' },
  { key: 'username' },
]

export default state
